import React, { createContext, useCallback, useContext, useEffect, useMemo } from 'react';
import { useUtils } from '../../../../context/UtilsContext';

const DietDataContext = createContext({
  dietCommonUtils: null,
  loading: false,
  error: null,
  refreshDietUtils: () => {},
});

export function useDietData() {
  return useContext(DietDataContext);
}

/**
 * Bootstrap diet common utils under /diet/* routes.
 * Reads through UtilsContext (session cache + shared in-memory state).
 * Mirrors WorkoutDataProvider — no catalog prefetch.
 */
export function DietDataProvider({ children }) {
  const {
    dietCommonUtils,
    dietUtilsLoading,
    dietUtilsError,
    fetchDietCommonUtils,
    clearDietCommonUtilsCache,
  } = useUtils();

  useEffect(() => {
    if (!dietCommonUtils) {
      fetchDietCommonUtils();
    }
  }, [dietCommonUtils, fetchDietCommonUtils]);

  const refreshDietUtils = useCallback(async () => {
    clearDietCommonUtilsCache?.();
    return fetchDietCommonUtils();
  }, [clearDietCommonUtilsCache, fetchDietCommonUtils]);

  const value = useMemo(
    () => ({
      dietCommonUtils,
      loading: dietUtilsLoading,
      error: dietUtilsError,
      refreshDietUtils,
    }),
    [dietCommonUtils, dietUtilsLoading, dietUtilsError, refreshDietUtils]
  );

  return (
    <DietDataContext.Provider value={value}>{children}</DietDataContext.Provider>
  );
}
